import { c as _c } from "react/compiler-runtime";
import { Box } from '@chakra-ui/react';
import { CommentSingle } from '@src/components/sco/Comments/CommentSingle';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { useRouter } from 'next/router';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default function Page() {
  const $ = _c(6);
  const router = useRouter();
  const activeContent = useActiveContentContext();
  let t0;
  if ($[0] !== activeContent) {
    t0 = () => {
      activeContent.setSiteSection("comments.single");
    };
    $[0] = activeContent;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useUniversalEffect(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ScoSiteNavBar />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["12px", "24px", "36px", "48px", "64px"];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${router.query.commentId}`;
  let t4;
  if ($[4] !== t3) {
    t4 = <Box>{t1}<Box marginX="auto" maxWidth="800px" padding={t2}><CommentSingle commentId={t3} /></Box></Box>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}